import { Component, OnInit, OnDestroy, ViewChild, AfterViewInit, ElementRef } from '@angular/core';
import axios from 'axios';
import * as XLSX from 'xlsx';
@Component({
  selector: 'app-queueandarear',
  templateUrl: './queueandarear.component.html',
  styleUrls: ['./queueandarear.component.css']
})
export class QueueandarearComponent implements OnInit, OnDestroy {

  @ViewChild('waitforweight', { static: false }) waitforweightTable: any;
  @ViewChild('truckwaitcall', { static: false }) truckwaitcallTable: any;
  @ViewChild('truckwaitcall') tb_data1: ElementRef;
  constructor() { }
  todaydate = new Date().toLocaleString('th-TH', { year: "numeric", month: "long", day: "2-digit", hour: "2-digit", minute: "2-digit" });
  ngOnInit(): void {
    this.LoadAreaandSugarCane();
    this.Loadwaitforweight();
    this.LoadCarinfrontt();
  }
  /*
    ngAfterViewInit(): void {
      setTimeout(() => {
        $(this.waitforweightTable.nativeElement).DataTable();
        $(this.truckwaitcallTable.nativeElement).DataTable();
      }, 800);
    }*/

  q1: any[]; q2: any[]; q3: any[]; q4: any[]; q6: any[];
  sumq: any[];

  LoadAreaandSugarCane() {
    let url = 'https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[dbQBRD].[dbo].[vw_wgtQtypenow]&w=1=1'
    axios.get(url)
      .then(res => {
        let data = res.data;
        this.q1 = data.filter((el: any) => el.qtype == 1);
        this.q2 = data.filter((el: any) => el.qtype == 2);
        this.q3 = data.filter((el: any) => el.qtype == 3);
        this.q4 = data.filter((el: any) => el.qtype == 4);
        this.q6 = data.filter((el: any) => el.qtype == 6);
        //console.log('q3', this.q3)
        this.sumq = [
          {
            'qaskum': (data.map((el: any) => { return parseFloat(el.wgtQtype2) })).reduce((a, b) => a + b, 0),
            'qcallsum': (data.map((el: any) => { return parseFloat(el.wgtQtype3) })).reduce((a, b) => a + b, 0),
            'qbooksum': (data.map((el: any) => { return parseFloat(el.wgtQtype1) })).reduce((a, b) => a + b, 0),

            'printQ1': (data.filter((el: any) => el.qtype != 2).map((el: any) => { return parseFloat(el.cntqtype1) })).reduce((a, b) => a + b, 0),
            'printQ2': (data.filter((el: any) => el.qtype != 2).map((el: any) => { return parseFloat(el.cntqtype2) })).reduce((a, b) => a + b, 0),
            'printQ3': (data.filter((el: any) => el.qtype != 2).map((el: any) => { return parseFloat(el.cntqtype3) })).reduce((a, b) => a + b, 0),
          }
        ]
      })
      .catch(err => { throw err });
  }

  // รถชั่งเข้าขณะนี้
  carinweight = [];
  countinweight: any = '';
  newtable1: any;
  Loadwaitforweight() {
    if (this.newtable1 != undefined || this.newtable1 != null) this.newtable1.destroy();
    axios.get('https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbbrr/cpc_online_w?print_q=4')
      .then(res => {
        let data = res.data;
        this.carinweight = data;
        this.countinweight = data.length;
        setTimeout(() => {
          this.newtable1 = $(this.waitforweightTable.nativeElement).DataTable();
        }, 400);
      })
      .catch(err => { throw err });
  }

  // รถ แจ้งคิว+เรียกคิว ขณะนี้
  carinfront = [];
  countcar = '';
  newtable2: any;
  LoadCarinfrontt() {
    if (this.newtable2 != undefined || this.newtable2 != null) this.newtable2.destroy();
    let url = 'https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[dbQBRD].[dbo].[vw_truckQueued]&w=1=1'
    axios.get(url)
      .then(res => {
        this.carinfront = res.data;
        let data = res.data.filter((el: any) => el.ref_doc1 !== 'Z');
        this.countcar = data.length;
        setTimeout(() => {
          this.newtable2 = $(this.truckwaitcallTable.nativeElement).DataTable();
        }, 400);
      })
      .catch(err => { throw err });
  }

  ExportExcelData1() {
    let date0 = new Date().toLocaleString('sv-SE', { year: "numeric", month: "2-digit", day: "2-digit" });
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(this.tb_data1.nativeElement);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'data_');
    console.log('date0:', date0);
    /* save to file */
    XLSX.writeFile(wb, `รถแจ้งคิวเรียกคิว_${date0}.xlsx`);
  }

  FormatThai(date: any) {
    if (!date) return '';
    const result = new Date(date);
    let thaiformat = result.toLocaleDateString('th-TH', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      timeZone: "UTC",
    });
    return thaiformat
  }

  ngOnDestroy(): void {
    this.q1 = null;
    this.q2 = null;
    this.q6 = null;
    this.carinweight = null;
  }

}
